import { ChartOption } from "@features/analysis/types/chartOption";
import i18n from "@i18n/i18n";
import BarChartIcon from "@mui/icons-material/BarChart";
import ViewListIcon from "@mui/icons-material/ViewList";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { observer } from "mobx-react";
import SankeyOptionsToggleButton from "./Charts/SankeyOptions";

interface ChartOptionsToggleProps {
  options: string[];
  onChange: (event: any, options: string[]) => void;
}

const ChartOptionsToggle = observer((props: ChartOptionsToggleProps) => {
  return (
    <ToggleButtonGroup value={props.options} onChange={props.onChange} size="small">
      <Tooltip title={i18n.t("results-tab.title.chart-options.show-grid")}>
        <span>
          <ToggleButton value={ChartOption.ShowGrid}>
            <ViewListIcon />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title={i18n.t("results-tab.title.chart-options.show-chart")}>
        <span>
          <ToggleButton value={ChartOption.ShowBarChart}>
            <BarChartIcon />
          </ToggleButton>
        </span>
      </Tooltip>
      <Tooltip title={i18n.t("results-tab.title.chart-options.sankey")}>
        <span>
          <SankeyOptionsToggleButton />
        </span>
      </Tooltip>
    </ToggleButtonGroup>
  );
});

export default ChartOptionsToggle;
